import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#2f8e79",
        secondary: "#2ea687",
        accent: "#ffc000",
        error: "#d23c3c",
      },
    },
  },
});
